var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    [
      _c("h1", [_vm._v("Custom Sized Picture & Photo Mounts")]),
      _c("p", [
        _vm._v(
          "Offering over 20 different mountboard colours in both very small sizes and extremely large sizes. This 1.4mm (1400micron) thick Larson-Juhl mountboard is perfect for displaying your artwork and photographs. \nYou may also add a white undermount to you order, this is perfect for artists or photographers selling their art as a whole product. "
        ),
      ]),
      _c("bespoke-mount", {
        attrs: {
          mountboards: _vm.mountboards,
          type: "standard",
          loading: _vm.loading,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }